import { render, staticRenderFns } from "./ColorCustomization.vue?vue&type=template&id=718deee5&scoped=true&"
import script from "./ColorCustomization.vue?vue&type=script&lang=js&"
export * from "./ColorCustomization.vue?vue&type=script&lang=js&"
import style0 from "./ColorCustomization.vue?vue&type=style&index=0&id=718deee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718deee5",
  null
  
)

export default component.exports